import { loadCategoriesRequest } from '../../store/categoriesSlice';

export default function initialRenderApis(dispatch) {
    dispatch(loadCategoriesRequest());
}